import React from 'react'

const CurrentOrder = () => {
  return (
    <div className="bg-white border rounded-xl p-4 sm:p-6">
      <h2 className="text-lg sm:text-xl font-semibold theme-text-primary">Current Order</h2>
      <div className="mt-4 text-gray-600">Your current order is empty.</div>
    </div>
  )
}

export default CurrentOrder

